import { createFileRoute } from '@tanstack/react-router';
import { DebugPage } from '@/features/debug/page/DebugPage';

export const Route = createFileRoute('/a/debug/')({
    component: DebugPage,
});
